<template>
<div class="inside_pages_right">
    <JobStructure></JobStructure>
    <!-- 班级摄像头 -->
    <div class="inside_pages_right_content-two">
        <div class="inside_pages_content_two" v-show="listBox == true">
            <div class="inside_pages_right_content">
                <div class="inside_pages_right_content_top">
                    <div class="inside_pages_right_content_top_left">
                        <el-button type="primary" size="mini" plain icon="el-icon-back"  @click="$Common.pageJump('/class_management',3)">
                        【{{classInfo.className}}】返回班级
                        </el-button>
                        <el-button type="primary" size="mini" plain icon="el-icon-circle-plus-outline"  @click="openAddBox()">添加摄像头</el-button>
                        <el-button type="primary" size="mini" plain icon="el-icon-circle-close" @click="delDataInfo()" :disabled="delDataList.length < 1 ? true : false">删除</el-button>
                    </div>
                </div>
                <div class="inside_pages_right_content_center">
                    <el-table  :data="responseData.list" height="100%"  border style="width: 100%" @selection-change="selectDeleteData">
                        <el-table-column type="selection" width="36"> 

                        </el-table-column>
                        <el-table-column  prop="monitorId" label="设备ID">
                        </el-table-column>

                        <el-table-column  prop="monitorChannel" label="通道号"  >
                        </el-table-column>

                        <el-table-column  prop="monitorName" label="摄像头名称">
                        </el-table-column>

                        <el-table-column  label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button type="danger"  size="mini" plain  icon="el-icon-circle-close"  @click="delDataInfo(scope.row.id)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="inside_pages_right_content_bottom" v-if="responseData.total > 0">
                    <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="responseData.pageNum"
                    :page-sizes="[20, 30, 50, 100]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="responseData.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog title="添加班级摄像头" :visible.sync="addBox" :append-to-body="true" direction="rtl" size="50%" :wrapperClosable="false" :close-on-press-escape="false">
            <div class="demo-drawer__content drawer_content_box">
                <form class="form-horizontal">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="monitorAreaId">
                                <option value="">请选择监控区域</option>
                                <option v-for="(value,key) in monitorAreaList" :key="key" :value="value.id">{{value.areaName}}</option>
                            </select>
                        </div>
                    </div>
                </form>
                <el-table :data="monitorAreaCameraList">
                    <el-table-column  prop="monitorId" label="ID">
                    </el-table-column>
                    <el-table-column prop="monitorName"  label="监控通道名称">
                    </el-table-column>
                    <el-table-column  label="操作">
                        <template slot-scope="rowData">
                            <el-button type="primary" plain size="mini" @click="addDataAction(rowData.row.monitorId)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import JobStructure from '@/components/JobStructure'
export default {
    name:'',
    components: {JobStructure},
    props: {},
    data() {
        return {
            listBox:true,
            addBox:false,
            editBox:false,

            // 批量删除安全小组的ID列表
            delDataList:[],

            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[],       // 数据列表
            },

            // 请求参数
            requestData :{
                pageNum : 1,
                pageSize : 20,
            },

            // 已选择的监控区域ID
            monitorAreaId:'',

            monitorAreaList:[],
            monitorAreaCameraList:[],

            classInfo:JSON.parse(sessionStorage.getItem('classInfo')) || '',

        };
    },
    watch: {
        monitorAreaId(){
            if(this.monitorAreaId==''){
                this.monitorAreaCameraList = []
                return false
            }
            this.getMonitorList()
        },

    },
    computed: {},
    methods: {

        // 打开新增
        openAddBox(){
            this.addBox = true
            this.getMonitoringArea()
        },

        // 获取监控区域
        async getMonitoringArea(){
			var newParamData = {
                schoolId:this.$store.state.schoolId,
            }
			let res = await  this.$Http.getMonitoringArea(newParamData)
			if(res.code == 200){
                this.monitorAreaList = res.data
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },

        // 获取监控列表
        async getMonitorList(){
			var newParamData = {
                schoolId:this.$store.state.schoolId,
                monitorAreaId:this.monitorAreaId
            }
			let res = await  this.$Http.getMonitorList(newParamData)
			if(res.code == 200){
                this.monitorAreaCameraList = res.data
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },


        // 添加数据
        async addDataAction(id){
            var parameData = {
                cameraId:id,
                classId:this.classInfo.id,
            }
            let res =  await this.$Http.addClassCamera(parameData,true)
            if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.messsage
                })
                this.getDataList()
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },

       
        // 数据显示每页的条数
        handleSizeChange(val) {
            this.requestData.pageSize = val
            this.getDataList()
           
        },

        // 数据翻页
        handleCurrentChange(val) {
            this.requestData.pageNum = val
            this.getDataList()
        },
       
        // 选择数据
        selectDeleteData(val) {
            this.delDataList = []
            for(var i = 0;i<val.length;i++){
                this.delDataList.push(val[i].id)
                
            }
            // console.log(this.delDataList);
        },

        // 删除
        delDataInfo(thisId=0){
            this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if(thisId>=1){
                    var requestData = [thisId]
                }else{

                    if(this.delDataList.length < 1){
                        this.$message({
                            type: 'error',
                            message: '请先选择您要删除的数据'
                        });
                        return false
                    }
                    var requestData = this.delDataList
                }

                
                let res =  await  this.$Http.delClassCamera(requestData)
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                }else if(res.code == 101){

                } else {
                    this.$message({
                        type: 'error',
                        message: res.messsage
                    });
                }
               
            }).catch(() => {}); 
        },
        // 获取数据列表
        async  getDataList(){
            var parameData = {
                pageNum:this.requestData.pageNum,
                pageSize:this.requestData.pageSize,
                classId:this.classInfo.id,
            }
            let res =  await this.$Http.getClassCamera(parameData,true)
            if(res.code == 200){
                this.responseData.pageSize = res.data.pageSize;
                this.responseData.pageNum = res.data.pageNum;
                this.responseData.total = res.data.total;
                this.responseData.pages = res.data.pages;
                this.responseData.list = res.data.list;
                // console.log(this.responseData.list)
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
            
        },

     
    },
    created() {},
    mounted() {
        if(this.classInfo == ''){
            this.$Common.pageJump('/class_management',3)
        }
        this.getDataList()
    }
};
</script>
<style scoped>
</style>